import { UPDATE_FOLLOWUS } from "../constants";

const initialState = null;

export const setFollousData = (data) => ({
    type: UPDATE_FOLLOWUS,
    data,
});

export const followus = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_FOLLOWUS:
            return action.data;
        default:
            return state;
    }
};
